import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { Loader } from "./components";

const Home = React.lazy(() => import("./pages/Home"));
const About = React.lazy(() => import("./pages/About"));
const MisionAndVision = React.lazy(() => import("./pages/Mision&Vision"));
const Infrastructure = React.lazy(() => import("./pages/Infrastructure"));
const Curriculam = React.lazy(() => import("./pages/Curriculam"));
const Contact = React.lazy(() => import("./pages/Contact"));
const Gallery = React.lazy(() => import("./pages/Gallery"));
const Teacher = React.lazy(() => import("./pages/Teacher"));
const CookiesPolicy = React.lazy(() => import("./pages/CookiesPolicy"));
const TermsOfServices = React.lazy(() => import("./pages/TermsOfServices"));
const PrivacyPolicy = React.lazy(() => import("./pages/PrivacyPolicy"));

function App() {
  return (
    <React.Suspense fallback={<Loader />}>
      <Switch>
        <Route path="/" component={Home} exact />
        <Route path="/about" component={About} exact />
        <Route path="/missionandvision" component={MisionAndVision} exact />
        <Route path="/infrastructure" component={Infrastructure} exact />
        <Route path="/curriculam" component={Curriculam} exact />
        <Route path="/contact" component={Contact} exact />
        <Route path="/gallery" component={Gallery} exact />
        <Route path="/teacher" component={Teacher} exact />
        <Route path="/cookies-policy" component={CookiesPolicy} />
        <Route path="/privacy-policy" component={PrivacyPolicy} />
        <Route path="/terms-of-services" component={TermsOfServices} />
        <Redirect from="*" to="/" />
      </Switch>
    </React.Suspense>
  );
}

export default App;
